<div class="floating-icon" *ngIf="checkboxValue"  [ngClass]="{ 'visible': checkboxValue }">
  <so-toggle-chat *ngIf="showChat" />

  <button *ngIf="!showChat" (click)="showChatFunction()" type="button"
    data-bs-toggle="modal" data-bs-target="#">
    <img src="assets/img/icono-compuesto-chat-soporte.svg" width="50"
      style="display: inline;margin-left: 10px;margin-bottom: 4px;">
  </button>
</div>
